const cards = [
  {
    tag: '最新爆料',
    title: '某知名艺人私密视频流出？完整版在线观看',
    desc: '近日网络疯传一段涉及某知名艺人的私密视频，引发全网热议。黑料网下载第一时间整理完整内容，供网友在线观看。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20scene%20with%20warm%20amber%20and%20deep%20red%20lighting%2C%20mysterious%20silhouette%2C%20dramatic%20atmosphere%2C%20modern%20digital%20art%2C%20editorial%20style%2C%20clean%20composition%2C%20soft%20gradients&width=800&height=500&seq=card-img-01&orientation=landscape',
    time: '2小时前',
    hot: true,
  },
  {
    tag: '娱乐圈',
    title: '顶流明星疑似恋情曝光，深夜密会画面流出',
    desc: '有网友拍到某顶流明星深夜与神秘女子同回公寓的画面，黑料在线持续跟进事件进展。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20nocturnal%20cityscape%20with%20warm%20crimson%20and%20golden%20accents%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20modern%20art%20style%2C%20editorial%20quality%2C%20soft%20bokeh%20effect%2C%20dark%20elegant%20tones&width=800&height=500&seq=card-img-02&orientation=landscape',
    time: '5小时前',
    hot: true,
  },
  {
    tag: '社会热点',
    title: '某企业高管内部录音曝光，黑料视频在线播放',
    desc: '一段涉及某知名企业高管的内部录音在网上流传，内容涉及商业机密，黑料网在线观看为您呈现。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20corporate%20scene%20with%20warm%20red%20and%20dark%20tones%2C%20silhouette%20figures%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20modern%20editorial%20style%2C%20high%20contrast&width=800&height=500&seq=card-img-03&orientation=landscape',
    time: '8小时前',
    hot: false,
  },
  {
    tag: '网红八卦',
    title: '知名网红直播中翻车，真实面目引发争议',
    desc: '某千万粉丝网红在直播中意外露馅，真实颜值引发网友热议，完整直播回放尽在黑料网。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20streaming%20scene%20with%20warm%20orange%20and%20deep%20crimson%20gradients%2C%20modern%20tech%20aesthetic%2C%20cinematic%20lighting%2C%20mysterious%20vibe%2C%20editorial%20quality%2C%20clean%20composition&width=800&height=500&seq=card-img-04&orientation=landscape',
    time: '12小时前',
    hot: false,
  },
  {
    tag: '独家揭秘',
    title: '某综艺节目幕后黑幕遭曝光，导演组内斗细节流出',
    desc: '多位知情人士向黑料网下载提供内部消息，揭露某热门综艺幕后的种种操作。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20backstage%20scene%20with%20dramatic%20amber%20spotlight%20and%20dark%20surroundings%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20warm%20and%20dark%20contrast%2C%20editorial%20style&width=800&height=500&seq=card-img-05&orientation=landscape',
    time: '1天前',
    hot: true,
  },
  {
    tag: '娱乐圈',
    title: '某女星被曝与经纪人关系暧昧，多张亲密照流出',
    desc: '网络流传一组某女星与经纪人的亲密照片，黑料在线观看为您整理完整合集。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20romantic%20scene%20with%20warm%20crimson%20and%20soft%20golden%20light%2C%20silhouette%20couple%2C%20cinematic%20moody%20atmosphere%2C%20editorial%20quality%2C%20modern%20art%20style%2C%20dark%20elegant%20tones&width=800&height=500&seq=card-img-06&orientation=landscape',
    time: '1天前',
    hot: false,
  },
  {
    tag: '最新爆料',
    title: '某平台头部主播涉嫌虚假宣传，完整证据链公布',
    desc: '打假博主曝光某头部主播带货产品的虚假宣传证据，黑料视频在线播放独家纪实。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20investigative%20scene%20with%20dramatic%20red%20and%20dark%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20editorial%20quality%2C%20modern%20art%20style%2C%20high%20contrast%20warm%20tones&width=800&height=500&seq=card-img-07&orientation=landscape',
    time: '2天前',
    hot: true,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-flashlight-fill"></i>
            实时更新
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            最新黑料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-lg mx-auto">
            全网最新最热的黑料视频在线观看资源，每日持续更新
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((card, i) => (
            <article key={i} className="group bg-background-50 border border-secondary-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden bg-secondary-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i < 3 ? undefined : 'lazy'}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {card.tag}
                  </span>
                </div>
                {card.hot && (
                  <div className="absolute top-3 right-3">
                    <span className="flex items-center gap-1 px-2 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                      <i className="ri-fire-fill text-xs"></i>
                      热门
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    查看详情
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6">
          <article className="group flex flex-col sm:flex-row bg-background-50 border border-secondary-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer">
            <div className="relative sm:w-[360px] shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-secondary-100">
              <img
                src={cards[6].img}
                alt={cards[6].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  {cards[6].tag}
                </span>
              </div>
              {cards[6].hot && (
                <div className="absolute top-3 right-3">
                  <span className="flex items-center gap-1 px-2 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    <i className="ri-fire-fill text-xs"></i>
                    热门
                  </span>
                </div>
              )}
            </div>
            <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {cards[6].title}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-3">
                {cards[6].desc}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {cards[6].time}
                </span>
                <span className="text-sm text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                  查看详情
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}